/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CashBoxesListFilterParams, CashBoxesListDto } from 'data/api/cashBoxes/cashBoxesClient.typings';
import { createAction } from '../../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../../utils/utils';
import { i18n } from '../../translation/i18n';
import { SoftwareVersionItemDto } from '../../api/cashRegisterModels/cashRegisterModelsClient.typings';

export enum CashBoxesActionType {
    OPEN_REGISTRY_CASHBOXES_LIST_PAGE = 'RegistryCashBoxesList/ open page',
    EXIT_REGISTRY_CASHBOXES_LIST_PAGE = 'RegistryCashBoxesList/ exit page',

    FETCH_NEXT_PAGE_START = 'RegistryCashBoxesList/ fetch next page start',
    APPLY_FILTERS = 'RegistryCashBoxesList/ apply filters',
    APPLY_FILTERS_FROM_OUTSIDE_SCREEN = 'RegistryCashBoxesList/ apply filters from outside screen',
    CHANGE_FILTERS = 'RegistryCashBoxesList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryCashBoxesList/ download cashboxes list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryCashBoxesList/ download cashboxes list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryCashBoxesList/ download cashboxes list as excel error',

    FETCH_CASHBOXES_LIST_PAGE_SUCCESS = 'RegistryCashBoxesList/ fetch cashboxes list page success',
    FETCH_CASHBOXES_LIST_PAGE_ERROR = 'RegistryCashBoxesList/ fetch cashboxes list page error',

    FETCH_CASH_REGISTERS_VERSIONS_LIST_START = 'ShortLists/ fetch cash register software versions start',
    FETCH_CASH_REGISTERS_VERSIONS_LIST_SUCCESS = 'ShortLists/ fetch cash register software versions success',
}

export const openRegistryCashBoxesListAction = () =>
    createAction(CashBoxesActionType.OPEN_REGISTRY_CASHBOXES_LIST_PAGE);

export const exitRegistryCashBoxesListAction = () =>
    createAction(CashBoxesActionType.EXIT_REGISTRY_CASHBOXES_LIST_PAGE);

export const fetchNextPageStartAction = () => createAction(CashBoxesActionType.FETCH_NEXT_PAGE_START);

export const applyFilteringAction = () => createAction(CashBoxesActionType.APPLY_FILTERS);

export const applyFiltersFromOutsideScreenAction = (params: CashBoxesListFilterParams) =>
    createAction(CashBoxesActionType.APPLY_FILTERS_FROM_OUTSIDE_SCREEN, params);

export const changeFiltersAction = (params: CashBoxesListFilterParams) =>
    createAction(CashBoxesActionType.CHANGE_FILTERS, params);

export const fetchCashBoxesListPageSuccessAction = (list: CashBoxesListDto) =>
    createAction(CashBoxesActionType.FETCH_CASHBOXES_LIST_PAGE_SUCCESS, {
        list,
        notification:
            list.cashBoxes.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchCashBoxesListPageErrorAction = (notification: Notification) =>
    createAction(CashBoxesActionType.FETCH_CASHBOXES_LIST_PAGE_ERROR, { notification });

export const downloadCashBoxesListAsExcelAction = () => createAction(CashBoxesActionType.DOWNLOAD_EXCEL);

export const downloadCashBoxesListAsExcelSuccessAction = () =>
    createAction(CashBoxesActionType.DOWNLOAD_EXCEL_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadCashBoxesListAsExcelErrorAction = (notification: Notification) =>
    createAction(CashBoxesActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchCashRegisterVersionsStartAction = (taxNumber: string) =>
    createAction(CashBoxesActionType.FETCH_CASH_REGISTERS_VERSIONS_LIST_START, taxNumber);

export const fetchCashRegisterVersionsSuccessAction = (list: SoftwareVersionItemDto[]) =>
    createAction(CashBoxesActionType.FETCH_CASH_REGISTERS_VERSIONS_LIST_SUCCESS, list);

export type CashBoxesAction =
    | ReturnType<typeof openRegistryCashBoxesListAction>
    | ReturnType<typeof exitRegistryCashBoxesListAction>
    | ReturnType<typeof fetchNextPageStartAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof applyFiltersFromOutsideScreenAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadCashBoxesListAsExcelAction>
    | ReturnType<typeof downloadCashBoxesListAsExcelSuccessAction>
    | ReturnType<typeof downloadCashBoxesListAsExcelErrorAction>
    | ReturnType<typeof fetchCashBoxesListPageSuccessAction>
    | ReturnType<typeof fetchCashRegisterVersionsStartAction>
    | ReturnType<typeof fetchCashRegisterVersionsSuccessAction>
    | ReturnType<typeof fetchCashBoxesListPageErrorAction>;
